export const GET_BARGAINS = 'GET_BARGAINS';
export const GET_BARGAIN_COUNT = 'GET_BARGAIN_COUNT'
export const UPDATE_USER = 'UPDATE_USER';
export const UPDATE_ADMIN_STATUS = 'UPDATE_ADMIN_STATUS'
export const UPDATE_USER_DATA = 'UPDATE_USER_DATA'